import { z } from 'zod';

export const FooterLinkSchema = z.object({
  title: z.string(),
  url: z.string(),
});

export type FooterLink = z.infer<typeof FooterLinkSchema>;
